import { Box, Button, Stack, Theme } from '@mui/material'
import styled from 'styled-components'

export const Container = styled(Box)<{ theme: Theme }>`
  background-color: ${({ theme }) => theme.palette.secondary.main};
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 18px;
  padding-bottom: 18px;
  border-radius: 10px;
`
export const InnerContainer = styled(Stack)`
  justify-content: center;
  align-items: center;
`

export const DaysButton = styled(Button)<{ selected: boolean; theme: Theme }>`
  width: 180px;
  text-transform: capitalize !important;
  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.primary.main : 'transparent'} !important;
  border-color: ${({ selected, theme }) =>
    selected
      ? theme.palette.primary.main
      : theme.palette.common.white} !important;
  color: ${({ theme }) => theme.palette.common.white} !important;
  font-weight: 700 !important;
`
